var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "posts-page"
  }, [_c('hero-section-blog', {
    attrs: {
      "fields": _vm.blogsPageSections.sections.blogs_hero_section.fields
    }
  }), _c('div', {
    staticClass: "posts-section"
  }, [_c('div', {
    staticClass: "main-container"
  }, [_c('div', {
    staticClass: "posts-section-header"
  }, [_c('category-filter', {
    attrs: {
      "value": _vm.selectedCategory ? _vm.selectedCategory.id : null,
      "categories": _vm.categories
    },
    on: {
      "input": _vm.selectCategory
    }
  }), _c('div', {
    staticClass: "search-bar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.searchPost,
      expression: "searchPost"
    }],
    staticClass: "paragraph-1-large",
    attrs: {
      "placeholder": _vm.$t('blog.search')
    },
    domProps: {
      "value": _vm.searchPost
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) return;
        _vm.searchPost = $event.target.value;
      }, _vm.listPosts]
    }
  }), _c('button', {
    staticClass: "search-bar-button"
  }, [_c('svg', {
    attrs: {
      "width": "25",
      "height": "25",
      "viewBox": "0 0 25 25",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M19.5 9.75C19.5 11.9062 18.7969 13.9219 17.625 15.5156L23.5312 21.4688C24.1406 22.0312 24.1406 23.0156 23.5312 23.5781C22.9688 24.1875 21.9844 24.1875 21.4219 23.5781L15.4688 17.625C13.875 18.8438 11.8594 19.5 9.75 19.5C4.35938 19.5 0 15.1406 0 9.75C0 4.40625 4.35938 0 9.75 0C15.0938 0 19.5 4.40625 19.5 9.75ZM9.75 16.5C13.4531 16.5 16.5 13.5 16.5 9.75C16.5 6.04688 13.4531 3 9.75 3C6 3 3 6.04688 3 9.75C3 13.5 6 16.5 9.75 16.5Z",
      "fill": "#F4F5F5"
    }
  })])])])], 1), _c('posts-grid', {
    attrs: {
      "posts": _vm.posts
    },
    on: {
      "viewPost": _vm.openPostDetailsPage
    }
  })], 1)])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }